<template>
	<div id="share">
		<img :src="imgurl" alt="">
		<div class="content" v-html="html">html</div>
		<div style="width: 100%; height: 173px;"></div>
		<Footer></Footer>
	</div>
</template>

<script>
	export default{
		data(){
		  return {
			name: '', // 标题
			html: '', // 文本
			imgurl: '', // 图片
		  }
		},
		created() {
			this.classesDetail()
		},
		metaInfo () {
			return {
				title: this.name
			}
		},
		methods:{
			async classesDetail(){
				let result = await this.$API.getClassesDetail(this.$route.params.id)
				 if(result.msg == '请求成功'){
				   this.name = result.data.name
				   this.html = result.data.description
				   this.imgurl = result.data.coverPicture
				 }else{
					 Toast('数据获取失败')
				 }
			},
		}
	}
</script>

<style lang="stylus" rel="stylesheet/stylus">
	#share
		width 100%
		.content
			width 100%
			height: 100%
			overflow hidden
		footer
			position fixed
			bottom 0
			z-index 999
</style>
